import React, { useState, useContext, Fragment, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Forms } from "../../components/backgrounds/Forms";
import { Primary } from "../../components/buttons/Primary";
import { Steps, titles } from "../../components/buttons/Steps";
import {
  ocupationOptions,
  economicActivityOptions,
  stratumOptions,
  bankAccountOptions,
  typeBankAccountOptions,
  creditSituationOptions,
  antiguedadMovilOptions,
  antiguedadCuentaBancariaOptions,
  hasAccountBank,
  monthlyExpensesOptions,
} from "../../utils/options_selects";
import { HttpRequest } from "../../services/httpRequest";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { SuccessAlert } from "../../components/alerts/successAlert";
import { AuthContext } from "../../context/Auth/AuthContext";
import { RecaptchaView } from "../../components/captcha/recaptcha";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import { FormOneContext } from "../../context/FormOne/FormOneContext";
import { FormTwoContext } from "../../context/FormTwo/FormTwoContext";
import { validateSessionAndJwtToken } from "../../utils/validateTokenSession";
import { variablesGlobales } from "../../configs/variables";
import { AuthService } from "../../services/auth/auth.service";
import { FunnelService } from "../../services/funnel/funnel.service";
import { returnToSignin } from "../../utils/returnToSign";
import { sanitizarInputNumerico, validarPalabrasNoPermititas } from "../../utils/validateData";
const cupoAprobado = "200000";

export function FormulariodosPage() {
  const { isValidReCaptcha } = useContext(AuthContext);
  const { updateCreditUser, creditUser } = useContext(CreditUserContext);
  const { updateFormOne } = useContext(FormOneContext);
  const { updateFormTwo } = useContext(FormTwoContext);
  const navigate = useNavigate();

  const [viewSpinner, setViewSpinner] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [viewalert, setViewalert] = useState(false);
  const [errorFieldOcupation, setErrorFieldOcupation] = useState("");
  const [errorFieldEconomicActivity, setErrorFieldEconomicActivity] =
    useState("");
  const [errorFieldMonthlyExpenses, setErrorFieldMonthlyExpenses] =
    useState("");
  const [errorFieldStratum, setErrorFieldStratum] = useState("");
  const [errorFieldHasAccount, setErrorFieldHasAccount] = useState("");
  const [errorFieldBankAccount, setErrorFieldBankAccount] = useState("");
  const [errorFieldTypeBankAccount, setErrorFieldTypeBankAccount] =
    useState("");
  const [errorFieldcreditSituation, setErrorFieldcreditSituation] =
    useState("");
  const [errorFieldantiguedadMovil, setErrorFieldantiguedadMovil] =
    useState("");
  const [
    errorFieldantiguedadCuentaBancaria,
    setErrorFieldantiguedadCuentaBancaria,
  ] = useState("");
  const [hasErrorFieldSelect, setHasErrorFieldSelect] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [newBankAccount, setNewBankAccount] = useState([]);
  const [dataUser, setDataUser] = useState("");

  const data = useLocation();
  const formOne = data.state;
  const doc = localStorage.getItem("doc");

  const payload = {};

  const [formTwo, setFormTwo] = useState({
    ocupation: "",
    economicActivity: "",
    monthlyExpenses: "",
    stratum: "",
    bankAccount: "",
    typeBankAccount: "",
    accountNumber: "",
    creditSituation: "",
    antiguedadMovil: "",
    antiguedadCuentaBancaria: "",
    tieneCuentaBancaria: "",
  });

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(isOpen);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(isOpen);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  function delteBankAccount() {
    const result = bankAccountOptions.filter(
      (resp) => resp.value !== 31 && resp.value !== 9
    );
    setNewBankAccount(result);
  }

  const handleAddTimeline = async (creditId, hasSuccess, errorMessage = "") => {
    try {
      let payloadTimeline = {
        name: "Formulario",
        description: "Información básica",
        pathView: `/formulariodos`,
        error: {
          hasError: !hasSuccess,
          errorMessage: errorMessage
        },
        success: {
          hasSuccess: hasSuccess,
          successMessage: "Ok"
        },
        styles: {
          TimelineOppositeContent: {
            sx: { m: "auto 0" },
            align: "right",
            variant: "body2",
            color: "text.secondary",
            style: { fontFamily: "GT Walsheim Pro", fontWeight: "lighter" }
          },
          TimelineDot: {
            color: ""
          },
          TimelineContent: {
            Typography: {
              variant: "h6",
              component: "span"
            },
            sx: { py: "12px", px: 2 }
          },
          icon: {
            name: "CiBoxList",
            size: "1.5rem"
          }
        }
      };
      if (creditId) {
        let { message } = await FunnelService.addTimelineByCreditId(creditId, payloadTimeline);
        return message;
      } else {
        return 'creditId is null.'
      }
    } catch (error) {
      return error;
    }
  }

  const getCreditById = async () => {
    try {
      let credit_id = localStorage.getItem('credit_id');
      if (!credit_id) throw Error('No existe en localstorage el atributo credit_id');
      const { message } = await HttpRequest.getCreditById(localStorage.getItem('credit_id'));
      return message;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormTwo({ ...formTwo, [name]: value });
  };

  const handleChangeSelect = (e) => {
    const { name, value } = e.target;
    setErrorFieldBankAccount("");
    setErrorFieldEconomicActivity("");
    setErrorFieldMonthlyExpenses("");
    setErrorFieldOcupation("");
    setErrorFieldStratum("");
    setErrorFieldTypeBankAccount("");
    setErrorFieldcreditSituation("");
    setErrorFieldantiguedadMovil("");
    setErrorFieldantiguedadCuentaBancaria("");
    setErrorFieldHasAccount("");
    setHasErrorFieldSelect(false);
    setFormTwo({ ...formTwo, [name]: value });
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getUserAuth(doc);
      setDataUser(data.message.user);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (event) => {
    handleClearStateAlert();
    updateFormOne(formOne);
    updateFormTwo(formTwo);

    try {
      event.preventDefault();
      if (!isValidReCaptcha) {
        return handleOpenAlert(
          "error",
          "Debe validar el captcha para continuar .",
          true
        );
      }
      if (
        formTwo.ocupation === "Selecciona una opción." ||
        formTwo.ocupation === ""
      ) {
        setErrorFieldOcupation("Por favor seleccione una ocupación.");
        return;
      } else if (
        formTwo.economicActivity === "Selecciona una opción." ||
        formTwo.economicActivity === ""
      ) {
        setErrorFieldEconomicActivity(
          "Por favor seleccione una actividad económica."
        );
        return;
      } else if (
        formTwo.monthlyExpenses === "Selecciona una opción." ||
        formTwo.monthlyExpenses === ""
      ) {
        setErrorFieldMonthlyExpenses(
          "Por favor seleccione sus ingresos mensuales."
        );
        return;
      }
      else if (
        formTwo.stratum === "Selecciona una opción." ||
        formTwo.stratum === ""
      ) {
        setErrorFieldStratum("Por favor seleccione un estrato.");
        return;
      } else if (
        formTwo.tieneCuentaBancaria === "Selecciona una opción." ||
        formTwo.tieneCuentaBancaria === "" ||
        formTwo.tieneCuentaBancaria === "0"
      ) {
        setErrorFieldHasAccount("Por favor responda si tiene cuenta bancaria.");
        return;
      } else if (
        formTwo.bankAccount === "Selecciona una opción." ||
        formTwo.bankAccount === "" ||
        formTwo.bankAccount === "0"
      ) {
        setErrorFieldBankAccount("Por favor seleccione una cuenta bancaria.");
        setHasErrorFieldSelect(true);
        return;
      } else if (
        formTwo.typeBankAccount === "Selecciona una opción." ||
        formTwo.typeBankAccount === ""
      ) {
        setErrorFieldTypeBankAccount(
          "Por favor seleccione un tipo de cuenta bancaria."
        );
        setHasErrorFieldSelect(true);
        return;
      } else if (
        formTwo.creditSituation === "Selecciona una opción." ||
        formTwo.creditSituation === "" ||
        formTwo.creditSituation === "0"
      ) {
        setErrorFieldcreditSituation(
          "Por favor seleccione su situación crediticia."
        );
        setHasErrorFieldSelect(true);
        return;
      } else if (
        formTwo.antiguedadMovil === "Selecciona una opción." ||
        formTwo.antiguedadMovil === "" ||
        formTwo.antiguedadMovil === "0"
      ) {
        setErrorFieldantiguedadMovil(
          "Por favor seleccione antiguedad del móvil."
        );
        setHasErrorFieldSelect(true);
        return;
      } else if (
        formTwo.antiguedadCuentaBancaria === "Selecciona una opción." ||
        formTwo.antiguedadCuentaBancaria === "" ||
        formTwo.antiguedadCuentaBancaria === "0"
      ) {
        setErrorFieldantiguedadCuentaBancaria(
          "Por favor seleccione antiguedad bancaria."
        );
        setHasErrorFieldSelect(true);
        return;
      }

      let coords = localStorage.getItem("coords");

      formOne.secondname = validarPalabrasNoPermititas(formOne?.secondname);
      formOne.secondlastname = validarPalabrasNoPermititas(formOne?.secondlastname);
      formTwo.accountNumber = sanitizarInputNumerico(formTwo.accountNumber);

      Object.assign(
        payload,
        {
          formOne,
          formTwo,
          doc: creditUser.documento || localStorage.getItem("doc"),
          coords: JSON.parse(coords),
          credit_id: localStorage.getItem('credit_id')
        }
      );

      handleSpinner(true);
      const responseService = await HttpRequest.sendPayloadFormsExperian(payload);
      let hasSuccessRequestCredit = true;
      let errorMessageRequestCredit = "";
      if (responseService.error) {
        hasSuccessRequestCredit = false;
        errorMessageRequestCredit = responseService.message?.message;
        if (responseService.message.errorCode === 506) {
          localStorage.clear();
          return navigate("/error");
        }
        handleSpinner(false);
        localStorage.setItem("type_user", variablesGlobales.typeUserVisitor);
        localStorage.clear();
        return navigate("/negado");
      }

      if (responseService.message.message === "APRUEBA") {
        const { info } = await getCreditById();
        if (info) {
          updateCreditUser({
            credit_id: info.credit_id,
            approvedQuota: info.approvedQuota || cupoAprobado,
            termInDays: info.termInDays,
            totalToPay: info.totalToPay,
            paydayLimit: info.paydayLimit,
            documento: info.documento,
            acceptanceDate: info.acceptanceDate,
            approvedDate: info.approvedDate,
            status: info.status,
          });
          localStorage.setItem("type_user", variablesGlobales.typeUSerClient);
          localStorage.setItem("is_signin", true);
        }
      }
      try {
        let creditId = localStorage.getItem('credit_id');
        if (creditId) {
          handleAddTimeline(creditId, hasSuccessRequestCredit, errorMessageRequestCredit)
            .then((message) => console.log(message))
            .catch(e => console.log(e))
        }
        let response = await AuthService.generateTokenClient({ doc: localStorage.getItem("doc") });
        localStorage.setItem('token', response?.message?.otp);
        handleSpinner(false);
        return navigate("/oferta");
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.log(error);
      handleSpinner(false);
      localStorage.clear();
      return navigate("/negado");
    }
  };


  const handleSpinner = (isView) => {
    setViewSpinner(isView);
  };

  useEffect(() => {

    loadInfoUser();
    delteBankAccount();

    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          setIsLoading(false);
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <div className="bg-red bg-opacity-10">
          <Steps
            estado1="complete"
            estado2="current"
            estado3="upcoming"
            estado4="upcoming"
          />
          <Forms
            title={titles[1].name}
            description={"Cargando la información."}
            form={
              <form action="#" method="POST">
                <div className="shadow-lg overflow-hidden rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="my-8"></div>
                  </div>
                </div>
              </form>
            }
          />
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {viewalert ? (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      ) : (
        <></>
      )}

      <div className="bg-purpleLight">
        <Steps
          estado1="complete"
          estado2="current"
          estado3="upcoming"
          estado4="upcoming"
        />
        <Forms
          isSpinner={viewSpinner}
          textSpinner={"Estimado cliente, estamos validando su información"}
          title={titles[1].name}
          form={
            <form action="#" method="POST" onSubmit={handleSubmit}>
              <div className="shadow-lg overflow-hidden rounded-md">
                <div className="px-4 py-5 bg-white sm:p-6">
                  <div className="grid grid-cols-8 gap-6">

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="ocupacion"
                        className="block text-sm font-medium"
                      >
                        Ocupación.
                      </label>
                      {ocupationOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="ocupation"
                          name="ocupation"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {ocupationOptions.map((item, index) => (
                            <option key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldOcupation}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="actividadeco"
                        className="block text-sm font-medium"
                      >
                        Actividad económica.
                      </label>
                      {economicActivityOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="economicActivity"
                          name="economicActivity"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {economicActivityOptions.map((item, index) => (
                            <option key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldEconomicActivity}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="actividadeco"
                        className="block text-sm font-medium"
                      >
                        Ingresos mensuales.
                      </label>
                      {monthlyExpensesOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="monthlyExpenses"
                          name="monthlyExpenses"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {monthlyExpensesOptions.map((item, index) => (
                            <option value={item.value} key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldMonthlyExpenses}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="gastos"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Estrato.
                      </label>
                      {stratumOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="stratum"
                          name="stratum"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {stratumOptions.map((item, index) => (
                            <option key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldStratum}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="gastos"
                        className="block text-sm font-medium text-gray-700"
                      >
                        ¿ Tienes una cuenta bancaria a tu nombre ?
                      </label>
                      {hasAccountBank && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="tieneCuentaBancaria"
                          name="tieneCuentaBancaria"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {hasAccountBank.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldHasAccount}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="banco"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Elige tu cuenta bancaria.
                      </label>

                      {newBankAccount && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="bankAccount"
                          name="bankAccount"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {newBankAccount.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      )}
                      {hasErrorFieldSelect ? (
                        <span
                          className="text-sm"
                          style={{ color: "#fc3e58", fontStyle: "italic" }}
                        >
                          {errorFieldBankAccount}
                        </span>
                      ) : (
                        <span className="text-sm text-purple">
                          Tip: Si tu cuenta es Bancolombia el desembolso será
                          mucho más rápido.
                        </span>
                      )}
                    </div>
                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="typeBankAccount"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Tipo de cuenta.
                      </label>
                      {typeBankAccountOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="typeBankAccount"
                          name="typeBankAccount"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {typeBankAccountOptions.map((item, index) => (
                            <option key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldTypeBankAccount}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="accountNumber"
                        className="block text-sm font-medium"
                      >
                        Número de cuenta.
                      </label>
                      <div>
                        <input
                          required
                          onChange={handleChange}
                          type="number"
                          name="accountNumber"
                          id="accountNumber"
                          maxLength="40"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        />
                      </div>
                      <span className="text-sm text-purple">
                        Este número cuenta debe estar a tu nombre para que
                        podamos aprobar tu solicitud.
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="creditSituation"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Situación crediticia.
                      </label>
                      {creditSituationOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="creditSituation"
                          name="creditSituation"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {creditSituationOptions.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldcreditSituation}
                      </span>
                      <span className="text-sm text-purple">
                        Responde con sinceridad para aumentar tus probabilidades
                        de aprobación.
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="antiguedadMovil"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Antiguedad del telefono móvil.
                      </label>
                      {antiguedadMovilOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="antiguedadMovil"
                          name="antiguedadMovil"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {antiguedadMovilOptions.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldantiguedadMovil}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="antiguedadCuentaBancaria"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Antiguedad de cuenta bancaria.
                      </label>
                      {antiguedadCuentaBancariaOptions && (
                        <select
                          required
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="antiguedadCuentaBancaria"
                          name="antiguedadCuentaBancaria"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {antiguedadCuentaBancariaOptions.map(
                            (item, index) => (
                              <option value={item.value} key={index}>
                                {item.label}
                              </option>
                            )
                          )}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldantiguedadCuentaBancaria}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <div className="pt-4 lg:mx-12 sm:mx-5">
                        <RecaptchaView></RecaptchaView>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex px-4 py-6 md:flex md:justify-end bg-white text-right sm:px-6">
                  <div className="flex text-base">
                    <span className="text-left pr-2 my-auto">
                      Revisa los datos antes de continuar.
                    </span>
                  </div>

                  <div className="md:w-56">
                    <Primary ty text="Continuar" />
                  </div>
                </div>
              </div>
            </form>
          }
        />
      </div>
    </Fragment>
  );
}
